import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  IconButton,
  LinearProgress,
  FormControl,
  MenuItem,
  Select,
  Grid,
  FormControlLabel,
  Switch,
  Checkbox,
  InputLabel,
  Slider,
} from "@mui/material";
import { display, styled } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { ScriptHtml } from "../../../utils";

import { useSelector } from "react-redux";
import { useDelete, useFetch, useFetchById, useUpdate } from "../../../hooks";
import { urls } from "../../../urls/urls";
import { BASE_URL_TEST } from "../../../utils/baseUrl";
import { SnackBarComponent } from "../../../components";

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"], // Remove formatting button
  ],
};

const handleClickrest = () => {
  alert("Reset Succesfull!");
};

const StyledPaper = styled(Paper)({
  padding: "16px",
  border: "1px solid #ddd",
  borderRadius: "4px",
  backgroundColor: "#fff",
});
const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#52d869", // ON state color
        opacity: 1,
      },
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.5,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 13,
    backgroundColor: "#ccc", // OFF state color
    opacity: 1,
  },
}));

const ImageItem = ({ name, error, onRemove }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      p: 1,
      border: "1px solid #ddd",
      borderRadius: "4px",
    }}
  >
    <img
      src={name}
      alt="Product thumbnail"
      style={{
        width: "50px",
        height: "50px",
        marginRight: "8px",
        objectFit: "cover",
      }}
    />
    <Box sx={{ flexGrow: 1 }}>
      <Typography variant="body2" color="textSecondary">
        {name}
      </Typography>
      <LinearProgress
        variant="determinate"
        value={100}
        sx={{
          height: "6px",
          borderRadius: "2px",
          mt: 1,
          backgroundColor: "inherit",
          "& .MuiLinearProgress-bar": {
            backgroundColor: error ? "red" : "green",
          },
        }}
      />
    </Box>

    <IconButton onClick={onRemove} sx={{ ml: 1 }}>
      <CloseIcon />
    </IconButton>
  </Box>
);

const ProductForm = ({
  onBack,
  openModal,
  selecteditem,
  isEditing,
  fetchData,
  menuData,
}) => {
  console.log("selecteditem", menuData, isEditing);
  const [selectedFile, setSelectedFile] = useState(null);
  const loginToken = useSelector((state) => state.user.logintoken);
  const { id } = useSelector((state) => state.user.userdetails);
  const [successMessage, setSuccessMessage] = useState(null);
  const imageInputRef = useRef(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selfDelivery, setSelfDelivery] = useState(false);
  const [selfpicking, setSelfPicking] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [existingImages, setExistingImages] = useState([]);
  const [selectedImageIds, setSelectedImageIds] = useState([]);
  const [priceRange, setPriceRange] = useState(0);

  const [vListingCategory, setVlistinCategory] = useState([]);

  const [snackbarState, setSnackbarState] = useState({
    open: false,
    severity: "success", // Default severity
    message: "",
    position: { vertical: "top", horizontal: "center" },
  });
  const userDetails = useSelector((state) => state.user.userdetails);
  const [selectedVendor, setSelectedVendor] = useState(selecteditem || null);

  const getInitialFormValues = () => ({
    categoryid: isEditing && menuData.category_id ? menuData.category_id : "",
    categoryname: isEditing && menuData.categoryname ? menuData.categoryname : "",
    vendor_id: isEditing ? menuData.vendor_id : "",
    vlisting_id: isEditing ? menuData.vlisting_id : "",
    description: isEditing ? menuData.description : "",
    name: isEditing ? menuData.name : "",
    quantity: isEditing ? menuData.quantity : "",
    price: isEditing ? menuData.price : "",
    self_delivery: isEditing ? menuData.self_delivery : "",
    self_pickup: isEditing ? menuData.self_pickup : "",
    image_ids: isEditing ? menuData?.image_ids : [],
    image_url: isEditing ? menuData.image_url : "",
    images: isEditing ? menuData.images : [],
    vendor: isEditing ? menuData.vendor : "",
    category_name: isEditing ? menuData.category_name : "",
    status: isEditing ? menuData.status : 0,
  });
  const userid = userDetails?.id;
  const [vProdNameError, setVProdNameError] = useState("");
  const [vImageError, setVImageError] = useState("");
  const [vDescError, setVDescError] = useState("");
  const [vQuantityError, setVQuantityError] = useState("");
  const [vPriceError, setVPriceError] = useState("");
  const [vCategoryIdError, setVCategoryIdError] = useState("");
  const [formValues, setFormValues] = useState(getInitialFormValues());

  console.log("vendor_id", id);
  const {
    data: categoryListData,
    error: categoryListError,
    isLoading: categoryListLoading,
    fetchData: categoryListFetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllListing"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: createCategoryData,
    isLoading: createCategoryLoading,
    error: createCategoryError,
    fetchData: fetchCreateData,
  } = useFetch(BASE_URL_TEST + urls("createVListing"), {
    method: "POST",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: updatedVListingData,
    isLoading: updatedVListingLoading,
    error: updatedVListingError,
    updateData: fetchUpdateData,
  } = useUpdate(BASE_URL_TEST, {
    method: "PUT",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: deleteImageData,
    isLoading: deleteImageLoading,
    error: deleteImageError,
    deleteData: fetchDeleteImageData,
  } = useDelete(BASE_URL_TEST, {
    method: "DELETE",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: categoryListByIdData,
    error: categoryListByIdError,
    isLoading: categoryListByIdLoading,
    fetchDataById: categoryListByIdFetchData,
  } = useFetchById(BASE_URL_TEST, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const handleFileChange = (event) => {
    const files = event.target.files;
    const validFiles = [];
    const errors = [];

    if (files) {
      if (selectedFiles.length + files.length > 3) {
        setErrorMessage("You can only upload up to 3 images.");
        return;
      }

      Array.from(files).forEach((file) => {
        if (file.type === "image/jpeg" || file.type === "image/png") {
          validFiles.push(file);
        } else {
          errors.push(
            `${file.name} is not a valid image. Only .jpg and .png are allowed.`
          );
        }
      });

      if (errors.length > 0) {
        setErrorMessage(errors.join(", "));
      } else {
        setErrorMessage(null);
      }

      setSelectedFiles((prev) => [...prev, ...validFiles]);
      setFormValues({ ...formValues, image_url: files[0] });
    }
  };
  console.log("selectedFFIles", selectedFiles);

  useEffect(() => {
    console.log("useEffectcalled", menuData, isEditing);
    if (isEditing) {
      const formattedImages = menuData["images"];
      // setUploadedImages(formattedImages);
      setSelectedImageIds(formattedImages.map((img) => img.vlising_image_id));
    }
    setFormValues({ ...formValues, image_ids: selectedImageIds });
  }, [menuData]);
  // console.log("useEffect selecttedImgid",selectedImageIds,formValues['image_ids'])

  useEffect(() => {
    const findByUrl = urls("vListingCategoriesFindById", userid);
    categoryListByIdFetchData(findByUrl);
  }, [userid]);

  useEffect(() => {
    if (deleteImageError) {
    } else if (deleteImageData && deleteImageData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: deleteImageData["message"],
        status: deleteImageData["status"],
      });
      // setDeleteModalOpen(true);
      // fetchData();
      setSelectedFiles([]);
    } else if (deleteImageData && deleteImageData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: deleteImageData["message"],
        status: deleteImageData["status"],
      });
      // setDeleteModalOpen(true);
      // fetchData();
    }
  }, [deleteImageData, deleteImageError]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  // const handleClicklist = () => {

  //   console.log("formvalues",formValues)
  //   if(isEditing)
  //   {
  //     if (formValues) {
  //       console.log("formValues", formValues);
  //       if (!formValues["categoryid"]) {
  //         setVCategoryIdError("Category is required");
  //         return;
  //       }
  //       if (!formValues["name"]) {
  //         setVProdNameError("Name is required");
  //         return;
  //       } else if (!formValues["description"]) {
  //         setVDescError("Description  is required");
  //       }

  //       if (!formValues["quantity"]) {
  //         setVQuantityError("Quantity is required");
  //         return;
  //       }
  //       if (!formValues["price"]) {
  //         setVPriceError("Price is required");
  //         return;
  //       }

  //       else {
  //         const formdata = new FormData();
  //         formdata.append("vendor_id",id);
  //         formdata.append("category_id",formValues['categoryid']);
  //         formdata.append("name", formValues["name"]);
  //         formdata.append("price", formValues["price"]);
  //         formdata.append("quantity", formValues["quantity"]);
  //         formdata.append("self_delivery", selfDelivery? 1 :0);
  //         formdata.append("self_pickup", selfpicking? 1 :0);
  //         formdata.append("description", formValues["description"]);
  //         formdata.append("images", formValues["image_url"]);

  //          const updateUrl = urls("updateVListing", formValues["vlisting_id"]);
  //            fetchUpdateData(updateUrl, formdata);
  //         setFormValues(getInitialFormValues());
  //       }
  //     }
  //   }
  //   else{
  //     if (formValues) {
  //       console.log("formValues", formValues);
  //       if (!formValues["categoryid"]) {
  //         setVCategoryIdError("Category is required");
  //         return;
  //       }
  //       if (!formValues["name"]) {
  //         setVProdNameError("Name is required");
  //         return;
  //       } else if (!formValues["description"]) {
  //         setVDescError("Description  is required");
  //       }

  //       if (!formValues["quantity"]) {
  //         setVQuantityError("Quantity is required");
  //         return;
  //       }
  //       if (!formValues["price"]) {
  //         setVPriceError("Price is required");
  //         return;
  //       }

  //       else {
  //         const formdata = new FormData();
  //         formdata.append("vendor_id",id);
  //         formdata.append("category_id",formValues['categoryid']);
  //         formdata.append("name", formValues["name"]);
  //         formdata.append("price", formValues["price"]);
  //         formdata.append("quantity", formValues["quantity"]);
  //         formdata.append("self_delivery", selfDelivery? 1 :0);
  //         formdata.append("self_pickup", selfpicking? 1 :0);
  //         formdata.append("description", formValues["description"]);
  //         formdata.append("images", formValues["image_url"]);

  //         fetchCreateData(formdata);

  //         setFormValues(getInitialFormValues());
  //       }
  //     }
  //   }

  // };

  const handleClicklist = () => {
  
    if (formValues) {
      if (!formValues["categoryid"]) {
        setVCategoryIdError("Category is required");
        return;
      }
      if (!formValues["name"]) {
        setVProdNameError("Name is required");
        return;
      } else {
        setVProdNameError("");
      }
    
           if (!formValues["price"]) {
        setVPriceError("Price is required");
        return;
      } else {
        setVPriceError("");
      }
      if (!formValues["quantity"]) {
        setVQuantityError("Quantity is required");
        return;
      } else {
        setVQuantityError("");
      }

      
 

      // Create FormData object
      let formdata = new FormData();
      formdata.append("vendor_id", id);
      formdata.append("category_id", formValues["categoryid"]);
      formdata.append("name", formValues["name"]);
      formdata.append("price", formValues["price"]);
      formdata.append("quantity", formValues["quantity"]);
      formdata.append("self_delivery", selfDelivery ? 1 : 0);
      formdata.append("self_pickup", selfpicking ? 1 : 0);
      formdata.append("description", formValues["description"]);
      formdata.append("status", formValues["status"]);

      if (isEditing && existingImages.length > 0) {
        const existingImageIds = existingImages.map(
          (img) => img.vlising_image_id
        );
        formdata.append("existing_image_ids", JSON.stringify(existingImageIds));
      }

      //  new images
      if (selectedFiles.length > 0) {
        selectedFiles.forEach((file, index) => {
          formdata.append("images", file);
        });
      }
      
      // Validate images: Check if there are either new files OR existing images
      const hasExistingImages = formValues.images && formValues.images.length > 0;
      const hasNewImages = selectedFiles.length > 0;
      
      if (!hasExistingImages && !hasNewImages) {
        setVImageError("Please select at least one image");
        return;
      } else {
        setVImageError(""); // Clear error if validation passes
      }

      if(selectedFiles.length > 3){
        setVImageError("Please select maximum 3 images");
        return;
      }

        if (!formValues["description"]) {
        setVDescError("Description is required");
        return;
      } else {
        setVDescError("");
      }
      console.log("inside hancle click list", formdata);
      // Submit the form
      if (isEditing) {
        const updateUrl = urls("updateVListing", formValues["vlisting_id"]);
        fetchUpdateData(updateUrl, formdata);
      } else {
        fetchCreateData(formdata);
      }

      // Reset form
      setFormValues(getInitialFormValues());
      setSelectedFiles([]);
      setExistingImages([]);
    }
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
  };

  useEffect(() => {
    if (selectedVendor && isEditing) {
      setFormValues(getInitialFormValues());

      // If there are images in the vendor data, set them as existing images
      if (selectedVendor.images && selectedVendor.images.length > 0) {
        setExistingImages(selectedVendor.images);
      }

      // Set the switch states based on the selected vendor
      setSelfDelivery(selectedVendor.self_delivery === 1);
      setSelfPicking(selectedVendor.self_pickup === 1);
    }
  }, [selectedVendor, isEditing]);

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => {
        setSuccessMessage(null);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [successMessage]);

  useEffect(() => {
    if (updatedVListingError) {
    } else if (updatedVListingData && updatedVListingData["status"] === true) {
      console.log("updatedCategoryData", updatedVListingData["data"]);

      setSnackbarState({
        ...snackbarState,
        open: true,
        message: updatedVListingData["message"],
        position: { vertical: "top", horizontal: "center" },
        severity: "success",
      });
      // setModalOpen(false);
      fetchData();
    }
  }, [updatedVListingData, updatedVListingError]);

  useEffect(() => {
    if (categoryListByIdError) {
    } else if (categoryListByIdData && categoryListByIdData.status == true) {
      setVlistinCategory(categoryListByIdData["data"]);
    }
  }, [categoryListByIdData, categoryListByIdError]);

  useEffect(() => {
    categoryListFetchData();
  }, []);

  useEffect(() => {
    if (categoryListError) {
    } else if (categoryListData && categoryListData["status"] == true) {
      setCategoryList(categoryListData["data"]);
    }
  }, [categoryListData, categoryListError]);

  useEffect(() => {
    if (createCategoryError) {
    } else if (createCategoryData && createCategoryData["status"] == true) {
      // setCategoryList(categoryListData['data'])
      console.log("createCategoryData", createCategoryData);
      setSnackbarState({
        ...snackbarState,
        open: true,
        message: createCategoryData["message"],
        position: { vertical: "top", horizontal: "center" },
        severity: "success",
      });
      openModal();
      fetchData();
    }
     else if (createCategoryData && createCategoryData["status"] == false) {
      // setCategoryList(categoryListData['data'])
      
      setSnackbarState({
        ...snackbarState,
        open: true,
        message: createCategoryData["message"],
        position: { vertical: "bottom", horizontal: "center" },
        severity: "error",
      });
      //openModal();
      //fetchData();
    }
  }, [createCategoryData, createCategoryError]);

  const handleImageClick = () => {
    imageInputRef.current?.click();
  };

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => {
        setSuccessMessage(null);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [successMessage]);

  const handleSnackbarClose = () => {
    setSnackbarState((prev) => ({ ...prev, open: false }));
  };

  const handleRemoveExistingImage = (imageId) => {
    setExistingImages((prevImages) =>
      prevImages.filter((image) => image.vlising_image_id !== imageId)
    );
  };

  const handleRemoveImage = (index) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
  };
  const removeImageFromForm = (imgid) => {
    console.log("Checkbox clicked imgid", imgid, selectedImageIds);
    const deleteUrl = urls("deleteListingImageById", imgid);

    fetchDeleteImageData(deleteUrl);
    // setSelectedImageIds((prev) => {
    //   const updated = prev.includes(imgid)
    //     ? prev.filter(id => id !== imgid)
    //     : [...prev, imgid];

    //   setFormValues((prevForm) => ({
    //     ...prevForm,
    //     image_ids: updated,
    //   }));
    //   setSelectedImageIds(updated)

    //   console.log("✅ Updated image_ids:", updated);

    //   return updated;
    // });
  };

  const getImageId = (img) => img.vlising_image_id || img.p_image_id;

  return (
    <>
      <Box sx={{ mt: 3, borderRadius: "12px" }}>
        <SnackBarComponent
          open={snackbarState.open}
          onClose={handleSnackbarClose}
          severity={snackbarState.severity}
          message={snackbarState.message}
          position={snackbarState.position}
        />
        <Box>
          <Box sx={{ display: "flex", gap: 2 }}>
            <StyledPaper sx={{ flex: 1 }}>
              <Box sx={{}}>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Typography variant="h6" gutterBottom display={"none"}>
                    Select category
                  </Typography>
                  <FormControl fullWidth sx={{ mb: 2 }} size="small">
                    <InputLabel>Select category</InputLabel>
                    <Select
                      name="category"
                      value={formValues.category_name}
                      error={!!vCategoryIdError}
                      helperText={
                        vCategoryIdError && (
                          <Typography
                            sx={{
                              textAlign: "left",
                              marginTop: 1,
                              color: "red",
                            }}
                          >
                            {vCategoryIdError}
                          </Typography>
                        )
                      }
                      onChange={(e) => {
                        // handleInputChange
                        const selectedName = e.target.value;
                        const selectedCategory =
                          vListingCategory?.listCategories?.find(
                            (c) => c.name === selectedName
                          );
                        setFormValues((prev) => ({
                          ...prev,
                          categoryid: selectedCategory?.category_id,
                          category_name: selectedCategory?.name,
                          
                        }));
                        setVCategoryIdError("");
                      }}
                      label="Select category"
                    >
                      {/* {categoryList &&
                        categoryList.map((item) => {
                          return (
                            <MenuItem value={item.category_id}>
                              {item.name}
                            </MenuItem>
                          );
                        })} */}

                      {vListingCategory?.listCategories &&
                        vListingCategory.listCategories.map((category) => (
                          <MenuItem
                            key={category?.category_id}
                            value={category?.name}
                          >
                            {category?.name}
                          </MenuItem>
                        ))}

                      {/* <MenuItem value="Seller2">Seller 2</MenuItem>
                      <MenuItem value="Seller3">Seller 3</MenuItem> */}
                    </Select>
                  </FormControl>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="h6" gutterBottom>
                    Name
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    name="productname"
                    error={!!vProdNameError}
                    helperText={
                      vProdNameError && (
                        <Typography
                          sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                        >
                          {vProdNameError}
                        </Typography>
                      )
                    }
                    value={formValues.name}
                    onChange={(e) =>
                      setFormValues({ ...formValues, name: e.target.value })
                    }
                    sx={{ mb: 2 }}
                  />
                </Box>
                <Box sx={{ display: "flex", gap: 2 }}>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="h6" gutterBottom>
                      Price
                    </Typography>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      name="price"
                      value={formValues.price}
                      inputProps={{ inputMode: "numeric" }}
                      onChange={(e) => {
                        const input = e.target.value;
                        if (/^\d*$/.test(input)) {
                          setFormValues({
                            ...formValues,
                            price: e.target.value,
                          });
                          setVPriceError("");
                        } else {
                          setVPriceError("Please enter only number");
                        }
                      }}
                      error={!!vPriceError}
                      helperText={
                        vPriceError && (
                          <Typography
                            sx={{
                              textAlign: "left",
                              marginTop: 1,
                              color: "red",
                            }}
                          >
                            {vPriceError}
                          </Typography>
                        )
                      }
                      sx={{ mb: 2 }}
                    />
                  </Box>
                  <Box sx={{ flex: 1, display: "none" }}>
                    <Typography variant="h6" gutterBottom>
                      Price
                    </Typography>
                    <Slider
                      value={formValues["price"]}
                      onChange={(event, newValue) => {
                        setFormValues({
                          ...formValues,
                          price: newValue,
                        });
                        setVPriceError("");

                        setPriceRange(newValue);
                      }}
                      valueLabelDisplay="auto"
                      min={0}
                      max={200000}
                      sx={{ marginBottom: "10px" }}
                    />

                    <Box style={{ marginBottom: "15px" }}>
                      Price: ₹{formValues && formValues["price"]}
                    </Box>
                  </Box>

                  <Box sx={{ flex: 1 }}>
                    <Typography variant="h6" gutterBottom>
                      Quantity
                    </Typography>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      name="quantity"
                      value={formValues.quantity}
                      error={!!vQuantityError}
                      helperText={
                        vQuantityError && (
                          <Typography
                            sx={{
                              textAlign: "left",
                              marginTop: 1,
                              color: "red",
                            }}
                          >
                            {vQuantityError}
                          </Typography>
                        )
                      }
                      inputProps={{ inputMode: "numeric", maxLength: 5 }}
                      onChange={(e) => {
                        const input = e.target.value;
                        if (/^\d*$/.test(input)) {
                          setFormValues({
                            ...formValues,
                            quantity: e.target.value,
                          });
                          setVQuantityError("");
                        } else {
                          setVQuantityError("Please enter only number");
                        }
                      }}
                      sx={{ mb: 2 }}
                    />
                  </Box>
                </Box>

                <Box sx={{ flexGrow: 1, padding: 3 }}>
                  <Grid container spacing={3}>
                    {/* Self-Delivery */}
                    <Grid item xs={12} md={6}>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 2 }}
                      >
                        <Typography>Self-delivery</Typography>
                        <FormControlLabel
                          control={
                            <CustomSwitch
                              checked={formValues["self_delivery"]}
                              onChange={(e) => {
                                setSelfDelivery(e.target.checked);
                                setFormValues({
                                  ...formValues,
                                  self_delivery: e.target.checked,
                                });
                              }}
                            />
                          }
                          label={selfDelivery ? "ON" : "OFF"}
                        />
                      </Box>
                    </Grid>
                    {/* Self-Pickup */}
                    <Grid item xs={12} md={6}>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 2 }}
                      >
                        <Typography>Self-pickup</Typography>
                        <FormControlLabel
                          control={
                            <CustomSwitch
                              checked={formValues["self_pickup"]}
                              onChange={(e) => {
                                setSelfPicking(e.target.checked);
                                setFormValues({
                                  ...formValues,
                                  self_pickup: e.target.checked,
                                });
                              }}
                            />
                          }
                          label={selfpicking ? "ON" : "OFF"}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
                {isEditing ? (
                                             <FormControl fullWidth sx={{ mb: 5 }}>
                                             <InputLabel>Status</InputLabel>
                                             <Select
                                              //  value={newVendor.status==0?0: 1} // Default to 1 (Active) 
                                              value={formValues.status}
                                               onChange={(e) =>
                                               { 
                                                 console.log("select",e.target.value)
                                                  // setNewVendor((prev) => ({ ...prev, status: e.target.value }))
                                                  setFormValues({...formValues,status:e.target.value})
                                             }
                                               }
                                               label="Status"
                                             >
                                               <MenuItem value={1}>Active</MenuItem>
                                               <MenuItem value={0}>Deactive</MenuItem>
                                             </Select>
                                           </FormControl>
                                        ) :null}
                <Grid item xs={12} md={6}>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="h6" gutterBottom>
                      Listing Description
                    </Typography>
                    <ReactQuill
                      theme="snow"
                      value={formValues?.description}
                      onChange={(value) =>
                        setFormValues({ ...formValues, description: value })
                      }
                      modules={modules}
                      style={{ height: "200px" }}
                      error={!!vDescError}
                      helperText={
                        vDescError && (
                          <Typography
                            sx={{
                              textAlign: "left",
                              marginTop: 1,
                              color: "red",
                            }}
                          >
                            {vDescError}
                          </Typography>
                        )
                      }
                    />
                  </Box>
                </Grid>
              </Box>
              <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mt: 7 }}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={handleClickrest}
                  style={{ padding: "10px 20px" }}
                >
                  Reset
                </Button>

                <Button
                  variant="contained"
                  color="success"
                  size="large"
                  onClick={handleClicklist}
                  style={{ padding: "10px 20px" }}
                >
                  {isEditing ? "Update Listing" : "Add Listing"}
                </Button>
              </Box>
            </StyledPaper>

            <Box sx={{ width: "35%" }}>
              <StyledPaper sx={{ mb: 2, textAlign: "center" }}>
                {/* {selectedFiles.length > 0 ? (
                  <img
                    // src={URL.createObjectURL(selectedFiles[0])}
                    src={existingImages.image_url}
                    alt="Product"
                    style={{ width: "80%" }}
                  />
                ) : (
                  <img
                    src="/placeholder.jpg"
                    alt="Placeholder"
                    style={{ width: "80%" }}
                  />
                )} */}

                {selectedFiles.map((file, index) => (
                  <Box
                    key={index}
                    sx={{
                      position: "relative",
                      width: 100,
                      height: 100,
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={URL.createObjectURL(file)}
                      alt="preview"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />

                    <Box
                      sx={{
                        position: "absolute",
                        top: 4,
                        right: 4,
                        background: "#ff4d4d",
                        color: "white",
                        width: 20,
                        height: 20,
                        borderRadius: "50%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        fontSize: "14px",
                      }}
                      onClick={() => handleRemoveImage(index)}
                    >
                      ×
                    </Box>
                  </Box>
                ))}

                {existingImages.length > 0 && (
                  <>
                    <Typography variant="subtitle1" gutterBottom>
                      Existing Images
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                        mb: 2,
                      }}
                    >
                      {existingImages.map((image) => (
                        <Box
                          key={image.vlising_image_id}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            p: 1,
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <img
                              src={image.image_url}
                              alt="Product"
                              style={{
                                width: "50px",
                                height: "50px",
                                marginRight: "8px",
                                objectFit: "cover",
                              }}
                            />
                            <Typography variant="body2" sx={{ flexGrow: 1 }}>
                              {image.image_url.split("/").pop()}
                            </Typography>
                          </Box>
                          <IconButton
                            onClick={() =>
                              handleRemoveExistingImage(image.vlising_image_id)
                            }
                          >
                            <CloseIcon />
                          </IconButton>
                        </Box>
                      ))}
                    </Box>
                  </>
                )}

                {selectedFiles.length > 0 && (
                  <>
                    <Typography variant="subtitle1" gutterBottom>
                      New Images
                    </Typography>
                    <Box
                      sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                    >
                      {selectedFiles.map((file, index) => (
                        <ImageItem
                          key={index}
                          name={URL.createObjectURL(file)}
                          error={
                            file.type !== "image/jpeg" &&
                            file.type !== "image/png"
                          }
                          onRemove={() => {
                            setSelectedFiles((prevFiles) =>
                              prevFiles.filter((_, i) => i !== index)
                            );
                          }}
                        />
                      ))}
                    </Box>
                  </>
                )}
              </StyledPaper>

              <StyledPaper>
                <Typography variant="h6" gutterBottom>
                  Listing Gallery
                </Typography>
                <Box
                  sx={{
                    border: "2px dashed #ddd",
                    borderRadius: "4px",
                    p: 2,
                    textAlign: "center",
                    mb: 2,
                    cursor: "pointer",
                  }}
                  onClick={() => imageInputRef.current?.click()}
                >
                  <img
                    src="/ph_image-light.svg"
                    alt="Product"
                    style={{ width: "20%" }}
                  />
                  <Typography variant="body1" color="textSecondary">
                    Drop your image here, or browse
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    500 x 500 pixcel less than 50kb
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Jpeg, png are allowed
                  </Typography>
                  <input
                    type="file"
                    accept="image/jpeg, image/png"
                    multiple
                    ref={imageInputRef}
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                </Box>

                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  {selectedFiles.map((file, index) => (
                    <ImageItem
                      key={index}
                      name={URL.createObjectURL(file)}
                      error={
                        file.type !== "image/jpeg" && file.type !== "image/png"
                      }
                      onRemove={() => {
                        setSelectedFiles((prevFiles) =>
                          prevFiles.filter((_, i) => i !== index)
                        );
                      }}
                    />
                  ))}
                </Box>

                {/* {formValues && Array.isArray(formValues.images)
                  ? formValues.images.map((item) => (
                      <Box
                        key={item.vlising_image_id} // Use a unique key from your data if available
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          p: 1,
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                        }}
                      >
                   
                        <img
                          src={item.image_url} // Use the dynamic image_url from your data
                          alt="Product thumbnail"
                          style={{
                            width: "50px",
                            height: "50px",
                            marginRight: "8px",
                            objectFit: "cover",
                          }}
                        />
                        <IconButton sx={{ ml: 1 ,display:'none'}}   onClick={() => {}}>
                          <CloseIcon />
                        </IconButton>
                      </Box>
                    ))
                  : null} */}

                {formValues && Array.isArray(formValues.images)
                  ? formValues.images.map((item) => (
                      <Box
                        key={item.vlising_image_id} // Use a unique key from your data if available
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          p: 1,
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                        }}
                      >
                        {/* <Checkbox defaultChecked onClick={() =>{
                 
                            removeImageFromForm(getImageId(item))
                             }}  /> */}

                        <IconButton
                          sx={{ ml: 1, display: "flex" }}
                          onClick={() => {
                            removeImageFromForm(getImageId(item));
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                        <img
                          src={item.image_url} // Use the dynamic image_url from your data
                          alt="Product thumbnail"
                          style={{
                            width: "50px",
                            height: "50px",
                            marginRight: "8px",
                            objectFit: "cover",
                          }}
                        />
                        <IconButton
                          sx={{ ml: 1, display: "none" }}
                          onClick={() => removeImageFromForm(item.p_image_id)}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Box>
                    ))
                  : null}

                {vImageError && (
                  <Typography
                    variant="body2"
                    sx={{ mt: 2, color: "red", fontWeight: "bold" }}
                  >
                    {vImageError}
                  </Typography>
                )}
              </StyledPaper>

              <Box
                sx={{ display: "none", justifyContent: "space-between", mt: 2 }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ width: "32%" }}
                  onClick={() => {}}
                >
                  UPDATE
                </Button>
                <Button variant="contained" color="error" sx={{ width: "32%" }}>
                  DELETE
                </Button>
                <Button
                  variant="contained"
                  color="inherit"
                  sx={{ width: "32%" }}
                  onClick={onBack}
                >
                  CANCEL
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ProductForm;
